module.exports = __webpack_public_path__ + "media/images/mv_img_about_sp-ba340933166915ff549b5c82c64d7b8d.png";